import React, {useContext, useEffect, useState} from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import logoXd from '../assets/img/small-logos/logo-xd.svg';
import logoAtlassian from '../assets/img/small-logos/logo-atlassian.svg';
import MostrarNotificacionModal from '../components/modals/MostrarNotificacionModal';
import resourcesServices from '../services/resourcesServices';
import { errorMessage } from '../errorHandler';
import BotonVolver from '../components/BotonVolver';

// USADO PARA EL ROL NOTIFICADO

const Notificaciones = () => {
  let { status } = useParams();
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [renderHTML, setRenderHTML] = useState(false)
  const [notificacionElegida, setNotificacionElegida] = useState(false)
  const [notificaciones, setNotificaciones] = useState([]);
  const [notificacionesNuevas, setNotificacionesNuevas] = useState([])
  const [notificacionesLeidas, setNotificacionesLeidas] = useState([])
  const [mostrarNotificaciones, setMostrarNotificaciones] = useState([])

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( authInformation.autenticado === true && (authInformation.rol === 'Obligado' || authInformation.rol === 'Apoderado')){
      setRenderHTML(true)
      obtenerNotificaciones()
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);

  useEffect(() => {
    const nuevas = notificaciones.filter(notificacion => (notificacion.estado === 'enviado' || notificacion.estado === 'para_enviar'))
    setNotificacionesNuevas(nuevas)
    const leidas = notificaciones.filter(notificacion => notificacion.estado === 'leido')
    setNotificacionesLeidas(leidas)
  }, [notificaciones]);

  useEffect(() => {

    if(status && status==='nuevas'){
      setMostrarNotificaciones(notificacionesNuevas)
    } else {
      setMostrarNotificaciones(notificacionesNuevas.concat(notificacionesLeidas))
    }

  }, [status, notificacionesLeidas, notificacionesNuevas]);

  const abrirNotificacion = (notificacion_id) => {
    navigate(`/notificacion/${notificacion_id}`);
  }

  const obtenerNotificaciones = async () => {
    try {
        const mensajes = await resourcesServices.obtenerResources('notificaciones');
        setNotificaciones(mensajes.data);
      } catch (error) {
        errorMessage(error)
      }
  }

  return (
    <div>
      <h1>Notificaciones <BotonVolver /></h1>
      {renderHTML && (

        <div className="card">
        <div className="card-header pb-0">
          <div className="row">
            <div className="col-lg-6 col-7">
              <p className="text-sm mb-0">
                <i className="fa fa-check text-info" aria-hidden="true"></i>
                <span className="font-weight-bold ms-1">{notificacionesNuevas.length}</span> no leidas / {notificacionesLeidas.length} leidas
              </p>
            </div>
          </div>
        </div>

        <div className="card-body px-0 pb-2">
          <div className="table-responsive">
            <table className="table align-items-center mb-0 table-hover">
              <thead>
                <tr>
                  <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Asunto</th>
                  <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Notificador</th>
                  <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha</th>
                </tr>
              </thead>
              <tbody>
                {mostrarNotificaciones && mostrarNotificaciones.map((notificacion, index) => {
                  return (
                    <tr key={index} role="button" onClick={()=>abrirNotificacion(notificacion.id)}>
                      <td>
                        <div className="d-flex px-2 py-1">
                          <div className="d-flex flex-column justify-content-center">
                            <div className={`mb-0 text-sm ${(notificacion.estado === 'enviado' || notificacion.estado === 'para_enviar') ? 'fw-bold' : ''}`} >{notificacion.asunto}</div>
                          </div>
                        </div>
                      </td>
                      <td>
                      {notificacion.usuario_notificador.value}
                      </td>
                      <td>
                      {notificacion.fecha_alta}
                      </td>
                    </tr>
                  )
                })
                }
              </tbody>
            </table>
          </div>
        </div>
        </div>

      )}
      <MostrarNotificacionModal notificacion={notificacionElegida} />
    </div>
  );
};

export default Notificaciones;